import type { FC } from 'react';
import { memo } from 'react';

import { SECTION_NAMES } from '@repo/common';
import Image from '../../../../../shared/components/Image';
import type { StandardJackpotProps } from '../../../types/jackpot.types';

import styles from './Static.module.css';

// Static jackpot displays a simple banner image like in the old lobby
const StaticJackpot: FC<StandardJackpotProps> = memo((props) => {
  // Use sectionName for assets because multiple sections can share one jackpot,
  // while their display jackpot names may differ
  const jackpotAssetName = props.sectionName.trim().toLowerCase().replace(/\s+/g, '_');

  return (
    <div
      className={`${styles.staticTheme} ${props.sectionName === SECTION_NAMES.HIGH_RTP ? styles.highRtpStaticTheme : ''}`}
    >
      <Image
        src={`/group_${jackpotAssetName}/default/logo`}
        alt={props.jackpotName}
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    </div>
  );
});

export default StaticJackpot;
